/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Totp_InvalidInputs */



/**
* | output |
* | --- |
* | "Invalid authenticator code. Please try again." |
*
* @param {Auth_Totp_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_totp_invalid = /** @type {((inputs?: Auth_Totp_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Totp_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültiger Authenticator-Code. Bitte erneut versuchen.")
	return /** @type {LocalizedString} */ ("Invalid authenticator code. Please try again.")
});